import { dropLast, takeLast, compose, endsWith, ifElse, identity} from 'ramda';
import { smartTranslate } from '../../../translator/smartTranslate';

const dataCvTest = 'data-cv-test';

const getSearchCanonical = href => ({rel: 'canonical', href, [dataCvTest]: 'Cv.Search.Canonical'});
const getSearchCanonicalPrev = href => ({rel: 'prev', href, [dataCvTest]: 'Cv.Search.CanonicalPrev'});
const getSearchCanonicalNext = href => ({rel: 'next', href, [dataCvTest]: 'Cv.Search.CanonicalNext'});

export const generateCanonicalLinks = (baseLink, currentPage, totalPages) => {
  const canonicalLinks = [];
  const filterFolderExists = baseLink.includes('filters');
  const baseLinkForCanonical = filterFolderExists ? baseLink.split('/filters')[0] : baseLink;
  canonicalLinks.push(getSearchCanonical(baseLinkForCanonical));


  return canonicalLinks;
};

const ensureSlash = ifElse(endsWith('/'), identity, x => `${x}/`);
const ensureNotSlash = ifElse(endsWith('/'), dropLast(1), identity);
const getParentCrumb = compose(takeLast(1), dropLast(1));
const normalizeBaseUrl = compose(ensureSlash);
const normalizeUrl = compose(ensureNotSlash);


export const preProcessBaseLink = (baseLink) => {
  const canonicalEnd = baseLink.substring(baseLink.lastIndexOf('/') + 1);
  const bodyStyleMap = {
    pickup: "truck",
  }
  const mappedLink = bodyStyleMap[canonicalEnd]
  baseLink = mappedLink ? baseLink.replace(canonicalEnd, mappedLink) : baseLink;
  return baseLink;
}

export const generateCanonicalLinksWithInventory = (baseLink, currentPage, totalPages, crumbs, vehicles, baseUrl) => {
  const canonicalLinks = [];
  const filterFolderExists = baseLink.includes('filters');
  baseLink = preProcessBaseLink(baseLink);
  const baseLinkWithoutFilters = filterFolderExists ? baseLink.split('/filters')[0] : baseLink;

  if (vehicles && vehicles.length === 0){
    const parentCrumb = getParentCrumb(crumbs);

    if (parentCrumb && parentCrumb.length) {
      const firstCrumb = parentCrumb[0];
      const normalizedBaseUrl = normalizeBaseUrl(baseUrl);
      canonicalLinks.push(getSearchCanonical(`${normalizedBaseUrl}${firstCrumb.urlResult.pathname}`));
    } else {
      const normalizedUrl = normalizeUrl(baseUrl);
      canonicalLinks.push(getSearchCanonical(`${normalizedUrl}`));
    }
  } else {
      canonicalLinks.push(getSearchCanonical(baseLinkWithoutFilters));
  }

  return canonicalLinks;
};



const ramMake = 'ram';
const ramPickup = 'pickup';

const isRamPickup = (make, model) => make === ramMake && model.includes(ramPickup);

export const generateVdpCanonicalLinks = (baseLink, make, model, year) => {
  const canonicalLinks = [];

  const parametersAreValid = () => {
    return !!((baseLink && make && model) && (year < 2100 && year > 1900));
  };

  if (!parametersAreValid()) {
    return canonicalLinks;
  }

  const humanReadableMake = make.toLowerCase();
  let humanReadableModel = model.toLowerCase();;

  if (isRamPickup(humanReadableMake, humanReadableModel)) {
    humanReadableModel = `${ramMake}_${humanReadableModel}`;
  }

  const smart = smartTranslate(
    `$/search/${humanReadableMake}/${humanReadableModel}/${year}`
  );

  canonicalLinks.push({
    rel: 'canonical',
    href: `${baseLink}/${smart.url}`,
    'data-cv-test': 'Cv.Vdp.Canonical'
  });

  return canonicalLinks;
};
